import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-entry-control',
  templateUrl: './entry-control.component.html',
  styleUrls: ['./entry-control.component.css']
})
export class EntryControlComponent {
  constructor(private location: Location, private appComponent:AppComponent) {
    this.appComponent.route.subscribe((route)=>{
      this.isActive = (route == "/control-ingreso") ? true : false;
    });
  }
  isActive: boolean=false;
  ngOnInit(): void {
    const currentPath = this.location.path();
    this.isActive = (currentPath === "/control-ingreso") ? true : false;
  }
}


